import { axios } from '@Root/API'

export const remove = (studyProgrammeId, referencePeriodStudentLoadId ) => {
	return axios.delete(`course-session/${studyProgrammeId}/reference-period-student-load/${referencePeriodStudentLoadId}`)
}
